import type { Router } from 'vue-router'

/**
 * 为路由表注入 SEO meta：
 * - canonical link
 * - og:url
 * - og:title / og:description
 *
 * 当前 index.html 已为首页设置静态 meta 标签。
 * 此函数让 /portfolio 与 /404 在切换时也能有正确 meta。
 */
const DEFAULT_DESCRIPTION =
  'Personal website of Wei YAN (yw79641760), a builder based in Hangzhou, China. Links to blog, GitHub, and professional profiles.'

export function setupSeoMeta(router: Router) {
  router.afterEach((to) => {
    // 不在 dev 静态 meta 上覆盖，仅在缺失时补充
    const description = (to.meta.description as string | undefined) ?? DEFAULT_DESCRIPTION
    const canonical = `https://yanwei.xyz${to.path === '/' ? '/' : to.fullPath}`

    setOrUpdate('meta[name="description"]', 'name', 'description', description)
    setOrUpdate('meta[property="og:url"]', 'property', 'og:url', canonical)
    setOrUpdate('link[rel="canonical"]', 'rel', 'canonical', canonical, 'href')
    setOrUpdate('meta[property="og:title"]', 'property', 'og:title', document.title)
    setOrUpdate('meta[name="twitter:title"]', 'name', 'twitter:title', document.title)
    if (description) {
      setOrUpdate('meta[property="og:description"]', 'property', 'og:description', description)
      setOrUpdate('meta[name="twitter:description"]', 'name', 'twitter:description', description)
    }
  })
}

/**
 * 设置或更新 meta/link 标签
 */
function setOrUpdate(
  selector: string,
  attrName: string,
  attrValue: string,
  content: string,
  contentAttr: string = 'content',
) {
  if (!content || typeof document === 'undefined') return
  let el = document.head.querySelector(selector)
  if (!el) {
    el = document.createElement(selector.startsWith('link') ? 'link' : 'meta')
    el.setAttribute(attrName, attrValue)
    document.head.appendChild(el)
  }
  el.setAttribute(contentAttr, content)
}
